export default "__VITE_ASSET__1AzVHRVG__"